import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";
import { Draggable } from "@hello-pangea/dnd";
import QuickListGroupList from "./QuickListGroupList";

const grid = 8;
const borderRadius = 3;

const Container = styled.div`
  margin: ${grid}px;
  display: inline-flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  border-top-left-radius: ${borderRadius}px;
  border-top-right-radius: ${borderRadius}px;
  background-color: var(--secondary-header-bg-color);
  border: 1px solid var(--msection-tab-border);
  height: 35px;
  transition: background-color 0.2s ease;
`;

const Title = styled.div`
flex-grow: 1;
user-select: none;
position: relative;
overflow: hidden;
text-align: center;
font-weight: 500;
font-size: 1rem;
color: var(--primary-color);
&:focus {
  outline: 2px solid var(--primary-color);
  outline-offset: 2px;
}
`;

const QuickListColumn = props => {

  const getDraggableContent = (provided) => (
      <Container className={"column"}
        ref={provided.innerRef}
        {...provided.draggableProps}>
        <Header {...provided.dragHandleProps}>
          <Title className={"header"}>
            {props.title}
          </Title>
        </Header>
        <QuickListGroupList
          listId={props.title}
          listType="QUOTE"
          quotes={props.items}
        />
      </Container>
    );


  return (
    <Draggable 
      draggableId={props.title} 
      index={props.index}
      children={getDraggableContent}
    />
  );
  
};

QuickListColumn.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  index: PropTypes.number.isRequired,
};
export default QuickListColumn;
